export default __webpack_public_path__ + "static/media/PR.301675a7.ico";